// 説明を記載するコンポーネント
import styles from 'shared/styles/styles';
import styled from 'styled-components';

export const DescriptionText = styled.div`
  margin-bottom: ${styles.input_component_margin_bottom};
`;

export default DescriptionText;
